import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "@/lib/api";

const FooterPage = () => {
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [message, setMessage] = useState("");
  const [services, setServices] = useState("");
  const [cta, setCta] = useState("");
  const [loading, setLoading] = useState(false);

  // Load current footer content on mount
  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const res = await axios.get("/content/footer");
        const data = res.data?.data;

        setPhone(data?.phone || "");
        setEmail(data?.email || "");
        setAddress(data?.address || "");
        setMessage(data?.message || "");
        setServices(data?.services || "");
        setCta(data?.cta || "");
      } catch (err) {
        toast.error("Failed to load footer data");
        console.error(err);
      }
    };

    fetchFooter();
  }, []);

  const handleSubmit = async () => {
    if (!phone || !email || !address || !message || !services || !cta) {
      return toast.error("All fields are required");
    }

    try {
      setLoading(true);
      await axios.put("/content/footer", {
        phone,
        email,
        address,
        message,
        services,
        cta,
      });
      toast.success("Footer info updated successfully!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update footer info");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl p-6 mx-auto bg-white rounded shadow">
      <h2 className="mb-4 text-2xl font-bold text-blue-900">
        Edit Footer Info
      </h2>

      {/* Phone */}
      <div className="mb-4">
        <label className="block mb-1 text-sm font-semibold text-blue-900">
          Phone
        </label>
        <input
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded"
          placeholder="+265 999 000 000"
        />
      </div>

      {/* Email */}
      <div className="mb-4">
        <label className="block mb-1 text-sm font-semibold text-blue-900">
          Email
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded"
          placeholder="contact@embracecarhire.com"
        />
      </div>

      {/* Address */}
      <div className="mb-4">
        <label className="block mb-1 text-sm font-semibold text-blue-900">
          Address
        </label>
        <input
          type="text"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded"
          placeholder="Blantyre, Malawi"
        />
      </div>

      {/* Message Line */}
      <div className="mb-4">
        <label className="block mb-1 text-sm font-semibold text-blue-900">
          Message (Top line above services)
        </label>
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded"
          placeholder="Explore our future services:"
        />
      </div>

      {/* Services List */}
      <div className="mb-4">
        <label className="block mb-1 text-sm font-semibold text-blue-900">
          Services (comma-separated)
        </label>
        <input
          type="text"
          value={services}
          onChange={(e) => setServices(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded"
          placeholder="Real Estate, Tours, Event Transport"
        />
      </div>

      {/* CTA Line */}
      <div className="mb-4">
        <label className="block mb-1 text-sm font-semibold text-blue-900">
          CTA Line
        </label>
        <input
          type="text"
          value={cta}
          onChange={(e) => setCta(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded"
          placeholder="Coming soon from Embrace Group 🚀"
        />
      </div>

      {/* Submit */}
      <button
        onClick={handleSubmit}
        disabled={loading}
        className="px-6 py-2 font-semibold text-blue-900 transition bg-yellow-400 rounded hover:bg-yellow-300"
      >
        {loading ? "Saving..." : "Save Changes"}
      </button>
    </div>
  );
};

export default FooterPage;
